import router from '@/modules/changePassword/router'
import ChangePasswordApi from '@/modules/changePassword/service'
import { useChangePasswordStore } from '@/modules/changePassword/store'

export default {
  router,
  service: new ChangePasswordApi(),
  store: useChangePasswordStore,
}
